export default [
  {
    path: 'confirmed-scientific-topic',
    name: 'confirmed-scientific-topic',
    component: () => import('@/views/pages/confirmed-scientific-topic/Index.vue'),
    meta: {
      pageTitle: 'Confirmed scientific topics',
      breadcrumb: [
        {
          text: 'Confirmed scientific topics',
          active: true,
        },
      ],
      resource: 'ScientificTopicProtocol',
      action: 'manage',
    },
  },
]
